import VehiclesIcon from '@kijiji/icons/src/icons/AllVehicles'
import ListingIcon from '@kijiji/icons/src/icons/Listings'
import { type TFunction } from 'next-i18next'
import { type ComponentType, type SVGProps } from 'react'

import { TRANSLATION_KEYS } from '@/constants/localization'
import { type ProfileQuery, isStandardProfile } from '@/features/profile/types/profile'

/**
 * This function returns a standardized label with the number of listings per seller
 * This function will return customized label for different types of sellers.
 *
 * This function uses the "TRANSLATION_KEYS.PROFILE" translations
 */
export const getSellerListingNumberLabel = (
  profile: ProfileQuery,
  isDealer: boolean,
  t: TFunction
): { label: string; icon: ComponentType<SVGProps<SVGSVGElement>> } | undefined => {
  const numberOfListings = profile.numberOfListings ?? 1
  const isSalesforceEnabled = isStandardProfile(profile) && profile.isSalesforceEnabled

  const icon = isDealer ? VehiclesIcon : ListingIcon
  /**
   * We don't know how many listings the seller has when they have a salesforce ID
   * We will return a different label in that case
   */
  if (isSalesforceEnabled)
    return {
      label: t(`${TRANSLATION_KEYS.PROFILE}:profile.metrics.listing_count.salesforce`),
      icon,
    }

  return {
    icon,
    label: t(
      `${TRANSLATION_KEYS.PROFILE}:profile.metrics.listing_count.${isDealer ? 'autos' : 'label'}`,
      {
        listingCount: numberOfListings,
      }
    ),
  }
}
